//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CopyEventTrigger",1,0],[0,"Name",1,0],[1,"ObjectToCopy",0,"SelectNXObjectList",0],[1,"StartOffset",0,"Expression",0],[1,"TimeInterval",0,"Expression",0]],[[["objects"],"SetObjectsToCopy",{},1,0]],[]];
SPLM.Mechatronics.ObjectSourceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ObjectSourceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ObjectSourceBuilder.CopyEventTriggerOption = Object.freeze({
    "TimeBased" : "TimeBased", "OncePerActivation" : "OncePerActivation"});

export default SPLM;